import { memo, createContext, useContext, useCallback, useMemo } from 'react'
import Portal from 'components/Portal';
import { useSelector } from 'react-redux';
import { LoaderSelector } from 'redux/selector';
import { show, hide } from 'redux/reducers/loader';
import { useDispatch } from 'react-redux';
import Loader from 'components/Loader';
// const Loader = lazy(() => import('components/Loader')); // , lazy, Suspense

const LoaderModal = (props) => {
  const dispatch = useDispatch()
  const visible = useSelector(LoaderSelector.visible)
  const _show = useCallback(() => dispatch(show()), [dispatch])
  const _hide = useCallback(() => dispatch(hide()), [dispatch])
  const dispatcher = useMemo(() => [_show, _hide], [_show, _hide])
  // const styles = useSpring({ opacity: visible ? 1 : 0 })

  return (
    <LoaderVisibility.Provider value={visible}>
      <LoaderDispatch.Provider value={dispatcher}>
        {props.children}
        <Portal portalClass="loader">
          {visible && <Loader className="position-fixed min-vw-100 min-vh-100" />}
        </Portal>
      </LoaderDispatch.Provider>
    </LoaderVisibility.Provider>
  )
}

export const LoaderDispatch = createContext()
export const LoaderVisibility = createContext(false)
export const useLoader = () => useContext(LoaderDispatch)
export const useLoaderVisibility = () => useContext(LoaderVisibility)

export default memo(LoaderModal);